const $ = require('jquery');

const $body = $('body'),
    $menuOverlay = $('.mobile-menu-overlay');

// toggle-menu
$('#toggle-mobile-menu').on('click', function(e) {
    e.preventDefault();
    if ($body.hasClass('show-menu')) {
        $body.removeClass('show-menu');
    } else {
        $body.addClass('show-menu');
    }
});

// close menu
$('#close-mobile-menu').on('click', function(e) {
    e.preventDefault();
    if ($body.hasClass('show-menu')) {
        $body.removeClass('show-menu');
    }
});

// add top offset if notification-bar is present
function setTopOffset() {
    let $notificationBar = $('.notification-bar');

    if ($notificationBar.length > 0) {
        $menuOverlay.css('top','auto');
        $menuOverlay.css('top', $notificationBar.outerHeight());
    }
}

setTopOffset();
$(window).on('resize', setTopOffset);